import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const motoristaFotoPadraoRepository = createRepository({
  path: 'motorista-foto-padrao',
  restApi
})

motoristaFotoPadraoRepository.atualizarFoto = (cpf, solicitacaoId) => {
  return restApi.patch(`/motorista-foto-padrao/${cpf}`, { solicitacaoId })
}

motoristaFotoPadraoRepository.fetchFotoPadrao = cpf => {
  return restApi.get(`/motorista-foto-padrao/${cpf}`)
}

export default motoristaFotoPadraoRepository
